<template>
  <div id="page-tips-shift" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="page-tips-shift py-3">
        <div class="content-loader" v-if="getLoading">
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
        </div>
        <div class="container">
          <p class="mb-4" v-if="id == null">
            <span class="titulo-pagina">Gestiona aquí tu reporte de turnos
            </span>
            <br />
            <span class="subtitulo-pagina">{{
                this.puntoVenta != null
                  ? this.puntoVenta.name
                  : this.nombreBodega | capitalize
            }}</span>
          </p>
          <div class="titutlo-editar" v-if="id > 0">
            <div class="row">
              <div class="col-md-12">
                <div style="display: flex">
                  <label class="mr-2 breadcrumb-link"><a href="../../../tipsreporthistory">Historial de
                      reportes</a></label>
                  <label class="breadcrumb-nolink">
                    > Detalle de tu reporte</label>
                </div>
              </div>
            </div>
            <p class="mb-4 ml-4">
              <span class="titulo-pagina">
                <h1>
                  Editar Reporte
                  {{ this.puntoVenta != null ? this.puntoVenta.name : "" }}
                </h1>
              </span>
            </p>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="card mb-4 card-personalizada">
                <div class="card-header card-header-left">
                  <h3 style="color:color: #263238;">Reporte de turnos</h3>
                </div>
                <div class="card-body col-12">
                  <!-- Managger -->
                  <div class="col-6" v-if="user.core_role_code == 'manager'">
                    <div class="buscar-empleado mt-4 mb-4">
                      <div class="input-group-prepend">
                        <span class="icon icon-search1"></span>
                      </div>
                      <input type="search" placeholder="Buscar empleado" aria-label="Buscar empleado" autocomplete="off"
                        class="form-control body_regular" v-model="searchTips" style="border: 0px; outline: 0;
    border: 0;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    box-shadow: none;" />
                    </div>
                  </div>
                  <!-- Supervisor -->
                  <div class="col-6" v-if="user.core_role_code == 'supervisor-bodegas'">
                    <b-form-select class="form-control p-4 mt-4 mb-4" v-model="bodegaSelected" :options="bodegas"
                      value-field="id" text-field="name" @change="cargarBodega($event)">
                      <b-form-select-option :value="null" selected>Punto de venta</b-form-select-option>
                    </b-form-select>


                  </div>
                  <div class="ml-4 mt-2 mb-1 mr-1">
                    <datatable :columns="datatableDP.columns" :data="this.filteredTipshift"
                      class="table table-hover table-borderless">
                      <template scope="{ row, columns }">
                        <tr :class="[row.selected ? 'selection-table' : '']">
                          <template>
                            <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row"
                              class="cell-border"></datatable-cell>
                          </template>
                        </tr>
                      </template>
                    </datatable>
                  </div>
                </div>
              </div>
              <div class="card card-personalizada mb-4">
                <div class="row" style="flex-direction: row; width: 100%">
                  <div class="col-xs-12 col-md-9 mb-3 mt-3 ml-1">
                    <b-form-checkbox v-model="checkedNovedad" name="check-button" switch size="lg" class="ml-4">
                      <span class="tbl_header" style="color: #546e7a; font-weight: 600">
                        ¿Tienes alguna novedad de nómina por reportar?</span>
                    </b-form-checkbox>
                  </div>
                  <div class="col-xs-6 text-center mb-3 mt-3">
                    <div class="text-novedad-info" v-b-popover.hover.topright="
                      'Un reporte de novedad de nómina puede llegar a ser un reemplazo o un rotativo'
                    ">
                      <span class="cta-small" style="color: #b0bec5">
                        Ver información
                      </span>
                      <span class="icon icon-info ml-2 mt-1" style="color: #b0bec5"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-12">
                  <div class="reloj-letras pl-2  mb-4" style="display: flex; flex-direction: row">
                    <div>
                      <img alt="Calendar" src="@/assets/images/icons/calendar.svg" />
                    </div>
                    <div class="ml-3" style="position: realtive; top: -1px">
                      <span class="tbl_header" style="font-weight: bold;color:#color: #546E7A;">Fecha de
                        reporte</span><br />
                      <span class="label-regular" style="color: #546e7a">
                        {{
                            this.fecha
                              ? this.$moment(this.fecha).format("LL")
                              : this.lastDateTipshiftReport
                                ? this.$moment(this.lastDateTipshiftReport).format(
                                  "LL"
                                )
                                : "Seleccione un punto de venta"
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-personalizada2" v-if="user.core_role_code == 'manager'">
                <div class="card-header">
                  <b class="card-header-text">Empleados seleccionados</b>
                </div>
                <div class="card-body text-center" style="width: 100%">
                  <h5 class="card-title" v-if="this.algunSeleccionado">
                    <span class="ml-3 body_regular" style="color: #78909c">Aún no has seleccionado ningún
                      empleado.</span>
                  </h5>
                  <div class="col-md-12" style="padding: 0; width: 300px">
                    <ul class="text-left list-group list-group-flush">
                      <div v-for="row in tipshift" :key="row.id">
                        <li v-if="row.selected" class="text-left">
                          <div class="badge">
                            <div class="btn-group text-left ml-4" style="
                                border-bottom: 1px solid #eceff1;
                                width: 340px;
                              ">
                              <span v-on:click="seleccionarRow(row, false)" class="mr-2" style="width: 30px">
                                <img alt="Eliminar" src="@/assets/images/icons/quitar.svg" />
                              </span>
                              <h6 class="card-text-name" v-b-tooltip.hover v-bind:title="row.nombre">
                                {{
                                    ("CC " + row.cc + " - " + row.nombre)
                                    | capitalize
                                }}
                              </h6>
                              <h6 class="card-text-cargo" v-b-tooltip.hover v-bind:title="row.cargo">
                                | {{ row.cargo | capitalize }}
                              </h6>
                            </div>
                            </div>
                          </li>
                        
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
                      <!-- user Supervisor -->
                      <div
                        class="card card-personalizada"
                        v-if="user.core_role_code == 'supervisor-bodegas'"
                    >
                      <div class="card-header">
                        <b class="card-header-text">Puntos de venta</b>
                      </div>
                      <div class="card-body">
                        <div class="col-md-12" style="padding: 0">
                          <ul class="text-left list-group list-group-flush">
                            <div v-for="bodega in bodegas" :key="bodega.id">
                              <li class="text-left">
                                <div class="badge ancho-completo">
                                  <div class="btn-group ancho-completo">
                                    <h6
                                        class="card-text-name-bodega"
                                        v-b-tooltip.hover
                                        v-bind:title="bodega.name"
                                    >
                                      {{ bodega.name | capitalize }}
                                    </h6>
                                    <span
                                        class="chips-bodega-proceso"
                                        v-if="bodegaSelected == bodega.id"
                                    >
                                <span
                                    class="icon icon-spinner9 iconProceso mr-1"
                                ></span>
                                <span class="ml-1 text-proceso">
                                  En proceso</span
                                >
                              </span>
                                    <span
                                        class="chips-bodega-pendiente"
                                        v-else-if="
                                  lastDateTipshiftReport != bodega.dateclose ||
                                  lastDateTipshiftReport == null ||
                                  bodega.dateclose == null
                                "
                                    >
                                <span
                                    class="
                                    icon icon-circle-clock
                                    iconPendiente
                                    mr-1
                                  "
                                ></span>
                                <span class="ml-1 text-pendiente">
                                  Pendiente</span
                                >
                              </span>
                                    <span
                                        class="chips-bodega-terminado"
                                        v-if="
                                  lastDateTipshiftReport == bodega.dateclose &&
                                  lastDateTipshiftReport != null &&
                                  bodega.dateclose != null
                                "
                                    >
                                <span
                                    class="icon icon-lock iconTerminado mr-1"
                                ></span>
                                <span class="ml-1 text-terminado">
                                  Terminado</span
                                >
                              </span>
                                  </div>
                                </div>
                              </li>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

          <div class="row">
            <div class="col-md-12" v-if="checkedNovedad">
              <h3>Selecciona el tipo de novedad a reportar:</h3>
              <div class="content-toggle">
                <div class="toggle-search">
                  <button type="button" name="btn_Reemplazos" class="btn_optionlogin" @click="ActiveBtnReemplazos"
                    :class="{ bn_active: activeBtn === 'Reemplazos' }">
                    <span class="cta ml-3"> Reemplazos</span>
                    <div class="Novedades" v-if="getTotalNovedades > 0">
                      {{ getTotalNovedades }}
                    </div>
                  </button>

                  <button type="button" name="btnRotativos" class="btn_optionlogin" @click="ActiveBtnRotativos"
                    :class="{ bn_active: activeBtn === 'Rotativos' }">
                    <span class="cta"> Rotativos</span>
                    <div class="Novedades" v-if="getTotalRotativos > 0">
                      {{ getTotalRotativos }}
                    </div>
                  </button>
                </div>
              </div>
              <b-card-text v-if="activeBtn == 'Reemplazos'">
                <div class="card" v-bind:class="
                  this.novedades.length > 0
                    ? 'card-personalizada3'
                    : 'card-personalizada3-enblanco'
                ">
                  <div class="card-header text-left card-header-novedad">
                    <b>¿Quién realizó el reemplazo?</b>
                  </div>
                  <div class="card-body ml-3">
                    <div class="row">
                      <div class="col-6 mt-3 mb-4">
                        <vue-bootstrap-typeahead class="
                            typehead typehead-n-border typehead-relative
                            text-buscar
                          " v-model="buscarNovedad" :data="listAutocompleteNovedad" :serializer="(item) => item.name"
                          @hit="colaboradorSeleccionado = $event" placeholder="Aún no has buscado ningún empleado"
                          style="width: 428px;">
                          <!-- Append a button -->
                          <template slot="prepend">
                            <span class="icon icon-search1"></span>
                          </template>
                        </vue-bootstrap-typeahead>
                        <span v-if="loadingAutocomplete" role="status">
                          <img class="spinner-logo mt-2" src="../../assets/images/login/master_isotipo_VP.svg"
                            style="margin: auto; width: 20px; height: 20px" alt="logo" />
                          <span class="sr-only">Loading...</span>
                        </span>
                      </div>
                      <div class="col-12">
                        <b-alert v-model="keyAlert" class="alert-custom-danger" variant="danger">
                          <span class="icon-warning text-warning"></span>
                          Actualmente <b>{{ msgAlertColaborador }}</b>
                          tiene un turno registrado en el punto de venta de
                          <b>{{
                              this.puntoVentaError != null
                                ? this.puntoVentaError.punto_venta
                                : ""
                          }}</b>. Si crees que se requiere corrección, ponte en
                          contacto con el Manager encargado.
                        </b-alert>
                      </div>
                    </div>
                    <div class="ml-4 mt-2 mb-1 mr-1" v-if="this.novedades.length > 0">
                      <datatable :columns="datatableNovedad.columns" :data="this.getNovedades"
                        class="table table-hover table-borderless">
                      </datatable>
                    </div>
                  </div>
                  <div class="card-body" style="width: 100%" v-if="this.novedades.length > 0">
                    <div class="text-left ml-4 text-novedad-descripcion">
                      <b>¿Tienes algo por contar acerca de esta novedad?</b>
                    </div>
                    <div class="baseline_box ml-4 mr-4" id="baseline_box1">
                      <textarea id="textarea" v-model="descripcion" class="ml-4 input-text" width="900px"
                        placeholder="Descripción de la novedad" @click="changeborder1(true)"
                        @blur="changeborder1(false)"></textarea>
                      <label for="textarea" class="label-helper">Descripción de la novedad </label>
                    </div>
                  </div>
                </div>
              </b-card-text>
              <b-card-text v-if="activeBtn == 'Rotativos'">
                <div class="card" v-bind:class="
                  this.novedades.length > 0
                    ? 'card-personalizada3'
                    : 'card-personalizada3-enblanco'
                ">
                  <div class="card-header text-left card-header-novedad">
                    <b>¿Quién realizó el turno rotativo?</b>
                  </div>
                  <div class="card-body ml-3">
                    <div class="row">
                      <div class="mt-3 mb-4 col-6">
                        <vue-bootstrap-typeahead class="
                            typehead typehead-n-border typehead-relative
                            text-buscar
                          " v-model="buscarNovedadRotativo" :data="listAutocompleteNovedad"
                          :serializer="(item) => item.name" @hit="colaboradorSeleccionadoRotativo = $event"
                          placeholder="Aún no has buscado ningún empleado" style="width: 428px">
                          <!-- Append a button -->
                          <template slot="prepend">
                            <span class="icon icon-search1"></span>
                          </template>
                        </vue-bootstrap-typeahead>
                        <span v-if="loadingAutocomplete" role="status">
                          <img class="spinner-logo mt-2" src="../../assets/images/login/master_isotipo_VP.svg"
                            style="margin: auto; width: 20px; height: 20px" alt="logo" />
                          <span class="sr-only">Loading...</span>
                        </span>
                      </div>
                      <div class="col-12">
                        <b-alert v-model="keyAlert" class="alert-custom-danger" variant="danger">
                          <span class="icon-warning text-warning"></span>
                          Actualmente <b>{{ msgAlertColaborador }}</b>
                          tiene un turno registrado en el punto de venta de
                          <b>{{
                              this.puntoVentaError != null
                                ? this.puntoVentaError.punto_venta
                                : ""
                          }}</b>. Si crees que se requiere corrección, ponte en
                          contacto con el Manager encargado.
                        </b-alert>
                      </div>
                    </div>
                    <div class="ml-4 mt-2 mb-1 mr-1" v-if="this.novedades.length > 0">
                      <datatable :columns="datatableNovedad.columns" :data="this.getRotativos"
                        class="table table-hover table-borderless">
                      </datatable>
                    </div>
                  </div>
                  <div class="card-body" style="width: 100%" v-if="this.novedades.length > 0">
                    <div class="text-left ml-4 text-novedad-descripcion">
                      <b>¿Tienes algo por contar acerca de esta novedad?</b>
                    </div>
                    <div class="baseline_box ml-4 mr-4" id="baseline_box1">
                      <textarea id="textarea" v-model="descripcion" class="ml-4 input-text" width="900px"
                        placeholder="Descripción de la novedad" @click="changeborder1(true)"
                        @blur="changeborder1(false)"></textarea>
                      <label for="textarea" class="label-helper">Descripción de la novedad </label>
                    </div>
                        </div>
                      </div>
                    </b-card-text>
                  </div>
                </div>

          <div class="row">
            <div class="col-md-12 mt-3" style="display: flex">
              <button :disabled="loadingConfirmar" class="button-danger" style="width: 200px; margin-right: 20px" pill
                v-on:click="descartar_reporte" v-if="id > 0">
                <span class="cta" style="width: 80%"> Descartar cambios </span>
                <span class="icon icon-cross" style="margin-left: 16px; width: 10%"></span>
              </button>
              <button :disabled="loadingConfirmar" class="button-primary button-confirmar"
                style="border: none; alig-text: right" pill v-on:click="update_reporte" v-if="id > 0">
                <span class="cta" style="width: 80%"> Guardar Cambios </span>
                <span class="icon icon-checkmark" style="margin-left: 16px; width: 10%"></span>
              </button>

              <button :disabled="loadingConfirmar" class="button-confirmar button-primary " style="border: none" pill
                v-on:click="confirmar_reporte" v-if="id == null">
                <span class="cta" style="width: 80%"> Confirmar reporte</span>
                <span class="icon icon-checkmark" style="margin-left: 16px; width: 10%"></span>
              </button>
            </div>

            <b-modal id="modal-scoped" centered hide-footer>
              <div style="
                  position: realtive;
                  display: flex;
                  width: 100%;
                  padding-top: 20px;
                  padding-bottom: 20px;
                  margin-bottom: 15px;
                ">
                <h1 class="display-1" style="margin: auto; width: auto; margin-bottom: 15px">
                  <span v-bind:class="modal_class"></span>
                </h1>
              </div>

              <h3 class="mt-20 mb-12 title-card" style="color: #263238">
                {{ modal_title }}
              </h3>
              <p class="table-value" style="
                  text-align: center;
                  color: #546e7a;
                  margin-top: 12px;
                  margin-bottom: 35px;
                ">
                {{ modal_msg }}
              </p>
              <div style="width: 100%">
                <button v-if="!loadingOn" @click="$bvModal.hide('modal-scoped')" type="button"
                  class="button-primary enviar-mensaje" style="border: none">
                  <span class="cta" width="100%">Confirmar</span>
                </button>

                <button v-else-if="loadingOn" class="button-primary enviar-mensaje" style="border: none" role="status">
                  <img class="spinner-logo" src="../../assets/images/login/master_isotipo_VP.svg"
                    style="margin: auto; width: 20px; height: 20px" alt="logo" />
                  <span class="sr-only">Loading...</span>
                </button>
              </div>
            </b-modal>
          </div>
          <!-- .layout-content -->
        </div>
      </div>
    </div>
  </div>

  <!-- #page-request -->
</template>

<script>
//import TemplateLetter from "./TemplateLetter.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import SelectRow from "@/components/datatables/SelectRow.vue";
import SelectAll from "@/components/datatables/SelectAll.vue";
import EditField from "@/components/datatables/EditField.vue";
import EditFieldDelete from "@/components/datatables/EditFieldDelete.vue";
import InfoModal from "@/components/core/modal/info-modal.vue";
//import moment from 'moment';

import { mapActions, mapState, mapGetters } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "tipshiftReport",
  components: {
    MainBarMenuV2,
    HeadingUser,
    InfoModal,
    alertV2: () => import('@/components/common/toasters/AlertV2.vue'),
    toasterInformative: () => import("@/components/common/toasters/Informative.vue"),
    ModalConfirmation: () => import('../../components/common/modal/ModalConfirmation.vue')
  },
  data() {
    return {
      textarea_novedades: "",
      activeBtn: "Reemplazos",
      id: this.$route.params.id == undefined ? null : this.$route.params.id,
      fecha:
        this.$route.params.fecha == undefined ? null : this.$route.params.fecha,
      pdv: this.$route.params.pdv == undefined ? null : this.$route.params.pdv,
      bodegaSelected:
        this.$route.params.pdv == undefined ? null : this.$route.params.pdv,
      puntoVentaError: {
        id: null,
        punto_venta: null,
        colaborador: null,
      },
      tienePdvAsignado: true,
      // Autocomplete novedades
      buscarNovedad: "",
      buscarNovedadRotativo: "",
      colaboradorSeleccionado: null,
      colaboradorSeleccionadoRotativo: null,
      novedadColaboradores: [],
      timestamp: this.$moment().format("LL"),

      runtime: null,

      validated: false,
      keyAlert: false,
      nombreBodega: "",

      idModalInfo: "idInfoModal",
      titleModalInfo: "¡Error!",
      contentModalInfo: "¡No tienes un punto de venta asignado!",
      statusClassModalInfo: "danger",
      // Mensajes alert
      msgAlertColaborador: "",

      // Modal
      modal_title: "¡Tu reporte se ha realizado exitosamente!",
      modal_msg:
        "No olvides que tu reporte de novedad depende de la confirmación de tu jefé de Zona",
      modal_class: "icon icon-success text-success",

      // response guardado
      response: [],
      checkedNovedad: false,
      descripcion: "",
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      dayBusiness: true,
      selected: false,
      // Datatable  reporte de turnos
      datatableDP: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "",
            align: "left",
            headerClass: "text-left",
            sortable: false,
            component: SelectRow,
            headerComponent: SelectAll,
          },
          {
            label: "Nombres y apellidos",
            field: "nombre",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              return "CC " + row.cc + " - " + row.nombre;
            },
          },
          {
            label: "Cargo",
            field: "cargo",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Propina",
            field: "close_value",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.close_value == undefined
                  ? 0
                  : row.close_value == null
                    ? 0
                    : row.close_value;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return " $ " + val;
            },
          },
          {
            label: "Puntaje",
            field: "point",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.point == undefined ? 0 : row.point == null ? 0 : row.point;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return val;
            },
          },
        ],
        rows: [],
      },

      // Datatable novedades
      datatableNovedad: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Nombres y apellidos",
            field: "name",
            align: "right",
            component: EditFieldDelete,
            headerClass: "text-right",
          },
          {
            label: "Cédula",
            field: "cc",
            align: "right",
            headerClass: "text-right",
          },
          {
            label: "Cargo Original",
            field: "position.name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Cargo Reemplazo",
            field: "position.name",
            align: "left",
            component: EditField,
            headerClass: "text-left",
          },
          {
            label: "Punto de venta",
            field: "site.name",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              if (row.pro_collaborators_point_sale == null) {
                return "";
              } else {
                return (
                  row.pro_collaborators_point_sale.pro_points_sale.code +
                  " - " +
                  row.pro_collaborators_point_sale.pro_points_sale.name
                );
              }
            },
          },
          {
            label: "Propina",
            field: "close_value",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.close_value == undefined
                  ? 0
                  : row.close_value == null
                    ? 0
                    : row.close_value;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return " $ " + val;
            },
          },
        ],
        rows: [],
      },

      // Datatable rotativos
      datatableRotativos: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Nombres y apellidos",
            field: "name",
            align: "right",
            component: EditFieldDelete,
            headerClass: "text-right",
          },
          {
            label: "Cédula",
            field: "cc",
            align: "right",
            headerClass: "text-right",
          },
          {
            label: "Cargo",
            field: "position.name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Tipo contrato",
            field: "is_direct",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              if (row.type_contract_id == undefined) {
                return "";
              } else {
                if (row.type_contract_id == null) {
                  return "";
                } else {
                  return row.type_contract_id == 5 ? "Directo" : "Tercerizado";
                }
              }
            },
          },
          {
            label: "Punto de venta",
            field: "site.name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Propina",
            field: "close_value",
            align: "left",
            headerClass: "text-left",
            representedAs: function (row) {
              let val =
                row.close_value == undefined
                  ? 0
                  : row.close_value == null
                    ? 0
                    : row.close_value;
              val = (val / 1).toFixed(2).replace(".", ",");
              val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return " $ " + val;
            },
          },
        ],
        rows: [],
      },

      selected_rows: [],

      showTurnReport: false,
      showTurn: false,
      emailTurnReport: 'Nomina@virtualpartner.com',
      reasonToBlocked: '',
      reasonDisable: '',
      showTurnReportApproved: false
    };
  },

  watch: {
    // Obtener cambios en el buscador
    buscarNovedad: function (newVal) {
      clearTimeout(this.runtime);
      this.runtime = setTimeout(() => {
        // Buscar autocomplete
        newVal = newVal.trim();
        if (newVal.length > 0) {
          this.actGetNovedades(newVal)
            .then(() => { })
            .catch((response) => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo seleccionar todos los registros: " + response;
            });
        }
      }, 1500);
    },

    // Obtener cambios en el buscador
    buscarNovedadRotativo: function (newVal) {
      clearTimeout(this.runtime);
      this.runtime = setTimeout(() => {
        // Buscar autocomplete
        newVal = newVal.trim();
        if (newVal.length > 0) {
          this.actGetNovedades(newVal)
            .then(() => { })
            .catch((response) => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo seleccionar todos los registros: " + response;
            });
        }
      }, 1500);
    },

    colaboradorSeleccionado: function (a) {
      // validar que no este repetido
      let nombre = a.name,
        cargo = a.position == null ? "" : a.position.name;

      nombre = nombre.toString();
      cargo = cargo.toString();

      nombre = nombre.toUpperCase();
      cargo = cargo.toLowerCase();

      nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
      cargo = cargo.charAt(0).toUpperCase() + cargo.slice(1);

      a.name = nombre;
      a.type = 1;
      a.position == null ? { id: null, name: "" } : (a.position.name = cargo);

      a.nuevoCargoId = a.position.id;
      a.nuevoCargoName = a.position.name;
      if (this.novedades.length == 0) {
        this.novedades.push(a);
      } else {
        let encontrado = null;
        encontrado = this.novedades.find((row) => row.id === a.id);
        if (encontrado == null) {
          this.actPushTableNovedades(a);
        }
      }
    },

    colaboradorSeleccionadoRotativo: function (a) {
      // validar que no este repetido
      let nombre = a.name,
        cargo = a.position == null ? "" : a.position.name;

      nombre = nombre.toString();
      cargo = cargo.toString();

      nombre = nombre.toUpperCase();
      cargo = cargo.toLowerCase();

      nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
      cargo = cargo.charAt(0).toUpperCase() + cargo.slice(1);

      a.name = nombre;
      a.type = 2;
      a.position == null ? { id: "", name: "" } : (a.position.name = cargo);
      if (this.novedades.length == 0) {
        this.novedades.push(a);
      } else {
        let encontrado = null;
        encontrado = this.novedades.find((row) => row.id === a.id);
        if (encontrado == null) {
          this.actPushTableNovedades(a);
        }
      }
    },

    /**
     * Consultar registros de solicitudes en proceso de aprobacion
     */
    showTurnReport() {
      if (this.showTurnReport) {
        this.getTurnReportLock()
      }
    }
  },
  beforeMount() {
    /***
     * Mira si el Manager esta bloqueado
     */
    this.IamIsLocked()

    if (this.user.core_role_code == "supervisor-bodegas") {
      this.actLoadBodegas();
      if (this.bodegaSelected != null) {
        this.obtenerData();
      }
    } else {
      this.obtenerData();
    }
  },
  beforeDestroy() {
    this.limpiar();
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modTipshiftReport", [
      "tipshift",
      "tipshiftCopia",
      "selectAll",
      "buscadorNovedad",
      "novedades",
      "novedadesCopia",
      "listAutocompleteNovedad",
      "listAutocompleteReemplazo",
      "algunSeleccionado",
      "loading",
      "filterTipshift",
      "bodegas",
      "puntoVenta",
      "loadingAutocomplete",
      "loadingConfirmar",
      "lastDateTipshiftReport",
      "loadingOn",
    ]),
    ...mapGetters("modTipshiftReport", [
      "getAllSelected",
      "getAll",
      "getAllNovedades",
      "filteredTipshift",
      "getLoading",
      "getNovedades",
      "getRotativos",
      "getTotalNovedades",
      "getTotalRotativos",
      "getCharges",
      'getErrorsToBlocked',
      'getIsBlocked',
      'getProcessing',
      'getReportLock',
      'getProcessingReportLock'
    ]),

    /*...mapMutations("modTipshiftReport",[
      'setLoading'
    ]),*/

    searchTips: {
      get() {
        return this.filterTipshift.query;
      },
      set(val) {
        this.actSetFilterTipshift(val);
      },
    },
  },

  mounted() {
    this.$root.$on("bv::modal::hidden", (bvEvent) => {
      if (bvEvent) {
        if (bvEvent.componentId == "modal-scoped") {
          if (this.id == null) {
            if (!this.response.error) {
              this.$router.push({
                path:
                  "/tipsreporthistory/" +
                  this.response.cierre.id +
                  "/" +
                  this.response.cierre.date +
                  "/" +
                  this.response.cierre.pro_point_sale_id,
              });
            }
          } else {
            this.$router.push({
              path:
                "/tipsreporthistory/" +
                this.response.cierre.id +
                "/" +
                this.response.cierre.date +
                "/" +
                this.response.cierre.pro_point_sale_id,
            });
          }
        }
      }
    });
  },

  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      value = value.toUpperCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actCheckedNovedad",
      "actSetBuscardorNovedad",
      "actGetNovedades",
      "actSetNullNovedades",
      "actPushTableNovedades",
      "actSetTableNovedades",
      "actSaveTurnosNovedades",
      "actUpdateTurnosNovedades",
      "actSetFilterTipshift",
      "actSetTipshift",
      "actSetNovedades",
      "actLoadBodegas",
      'IamIsLocked',
      'enableToTurnReport',
      'getTurnReportLock'
    ]),
    showDetailTurnReport ({ reason }) {
      this.reasonDisable = reason
      this.$bvModal.show('show-detail-turn-report')
    },
    sendEnableToTurnReport() {
      this.enableToTurnReport({ reason: this.reasonToBlocked }).then(() => {
          this.$bvModal.show('propinas-modal-success')
          this.getTurnReportLock()
      })
    },
    limpiar() {
      this.actSetNullNovedades();
      this.actSetTableNovedades([]);
      this.actSetTipshift([]);
      this.actSetNovedades([]);
    },
    changeborder1(change) {
      if (change) {
        document.getElementById("baseline_box1").style.borderColor = "#5D5FEF";
        this.textarea_novedades = "valor";
      } else {
        document.getElementById("baseline_box1").style.borderColor = "#78909C";
        this.textarea_novedades = document.getElementById("textarea").value;
      }
    },
    ActiveBtnReemplazos() {
      this.activeBtn = "Reemplazos";
    },

    ActiveBtnRotativos() {
      this.activeBtn = "Rotativos";
    },

    cargarBodega(e) {
      this.actSetNovedades([]);
      let bodega = null;
      bodega = this.bodegas.find((bodega) => bodega.id == e);
      this.nombreBodega = bodega != null ? bodega.name : "";
      if (this.bodegaSelected != null) {
        this.obtenerData();
      }
    },

    obtenerData() {
      let datos, id, editar, fecha, id_user;
      id = this.id == null ? this.user.id : this.id;
      id_user = this.user.id;
      editar = this.id == null ? false : true;
      fecha = this.fecha == null ? null : this.fecha;
      datos = {
        id: id,
        id_user: id_user,
        fecha: fecha,
        editar: editar,
        rol: this.user.core_role_code,
        point_sale_id: this.bodegaSelected,
        date: fecha,
      };
      this.actGetTipshift(datos)
        .then((datos) => {
          // calcular cantidad de novedades
          this.checkedNovedad = this.novedades.length > 0 ? true : false;
          this.descripcion =
            this.novedades.length > 0 ? this.novedades[0].description : "";
          if (datos.error) {
            this.tienePdvAsignado = false;
            this.$bvModal.show(this.idModalInfo);
          }
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;
        });
    },

    seleccionarRow(row, selected) {
      row.selected = selected;
      this.actSelectRow(row)
        .then(() => { })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo seleccionar todos los registros: " + response;
        });
    },

    descartar_reporte() {
      this.$router.push("/tipsreporthistory");
    },

    // update cambios reporte
    update_reporte() {
      this.keyAlert = false;
      let data = {};
      let configData = {
        type: 1,
        description: this.descripcion,
      };
      let turnos_seleccionado = this.getAllSelected(true, true, this.fecha);
      let novedades = this.getAllNovedades(configData, this.fecha);
      if (turnos_seleccionado.length == 0) {
        this.modal_title = "¡Selecciona un turno!";
        this.modal_msg = "";
        this.modal_class = "icon icon-deny text-danger";
      }

      data = {
        punto_venta_id: this.tipshift[0].pro_point_sale_id,
        pro_close_point_sale_id: parseInt(this.id),
        colaboradores: turnos_seleccionado,
        novedadesNomina: novedades,
        date: this.lastDateTipshiftReport,
      };

      this.actUpdateTurnosNovedades(data)
        .then((response) => {
          this.error.flag = false;
          this.response = response;
          if (!response.error) {
            this.modal_title = "¡Tu reporte se ha realizado exitosamente!";
            this.modal_msg =
              "No olvides que tu reporte de novedad depende de la confirmación de tu jefé de Zona";
            this.modal_class = "icon icon-success text-success";
            this.$bvModal.show("modal-scoped");
          } else if (response.error) {
            this.error.flag = true;
            if (response.key == 0) {
              this.modal_title = "¡Error actualizando los turnos!";
              this.modal_msg = response.message;
              this.modal_class = "icon icon-deny text-danger";

              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo conectar al servicio: error: " + response.message;

              this.$bvModal.show("modal-scoped");
            } else if (response.key == 1) {
              this.keyAlert = true;
              this.puntoVentaError = response.collaborator;
              this.msgAlertColaborador = response.collaborator.colaborador;

              this.modal_title = "¡Error actualizando los turnos!";
              this.modal_msg =
                "Actualmente " +
                this.msgAlertColaborador +
                " tiene un turno registrado en el punto de venta de " +
                (this.puntoVentaError != null
                  ? this.puntoVentaError.punto_venta
                  : "") +
                "Si crees que se requiere corrección, ponte en contacto con el Manager encargado.";
              this.modal_class = "icon icon-deny text-danger";

              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "";

              this.$bvModal.show("modal-scoped");
            }
          }
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;

          this.modal_title = "¡Error guardando los turnos!";
          this.modal_msg = "";
          this.modal_class = "icon icon-deny text-danger";
          this.$bvModal.show("modal-scoped");
        });
    },

    // Confirmar y guardar reporte
    confirmar_reporte() {
      let data = {};
      let configData = {
        type: 1,
        description: this.descripcion,
      };
      let turnos_seleccionado = this.getAllSelected(
        true,
        false,
        this.lastDateTipshiftReport
      );
      let novedades = this.getAllNovedades(configData, null);
      if (turnos_seleccionado.length == 0) {
        this.modal_title = "¡Selecciona un turno!";
        this.modal_msg = "";
        this.modal_class = "icon icon-deny text-danger";
      }

      data = {
        punto_venta_id:
          this.tipshift[0].pro_point_sale_id != undefined
            ? this.tipshift[0].pro_point_sale_id
            : this.bodegaSelected,
        colaboradores: turnos_seleccionado,
        novedadesNomina: novedades,
        date: this.lastDateTipshiftReport,
      };

      this.actSaveTurnosNovedades(data)
        .then((response) => {
          this.error.flag = false;
          this.response = response;
          if (!response.error) {
            this.modal_title = "¡Tu reporte se ha realizado exitosamente!";
            this.modal_msg =
              "No olvides que tu reporte de novedad depende de la confirmación de tu jefé de Zona";
            this.modal_class = "icon icon-success text-success";
            this.$bvModal.show("modal-scoped");
          } else if (response.error) {
            this.error.flag = true;
            if (response.key == 0) {
              this.modal_title = "¡Error guardando los turnos!";
              this.modal_msg = response.message;
              this.modal_class = "icon icon-deny text-danger";

              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo conectar al servicio: error: " + response.message;

              this.$bvModal.show("modal-scoped");
            } else if (response.key == 1) {
              this.keyAlert = true;
              this.puntoVentaError = response.collaborator;
              this.msgAlertColaborador = response.collaborator.colaborador;

              this.modal_title = "¡Error guardando los turnos!";
              this.modal_msg =
                "Actualmente " +
                this.msgAlertColaborador +
                " tiene un turno registrado en el punto de venta de " +
                (this.puntoVentaError != null
                  ? this.puntoVentaError.punto_venta
                  : "") +
                " Si crees que se requiere corrección, ponte en contacto con el Manager encargado.";
              this.modal_class = "icon icon-deny text-danger";

              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "";

              this.$bvModal.show("modal-scoped");
            }
          }
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;

          this.modal_title = "¡Error guardando los turnos!";
          this.modal_msg = "";
          this.modal_class = "icon icon-deny text-danger";
          this.$bvModal.show("modal-scoped");
        });
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },

    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/solicitudes" });
      }
    },

    hideModalAvailability() {
      this.$router.push({ path: "/solicitudes" });
    },

    hideModalSociety() {
      this.society = [];
      this.$refs["my-modal-society"].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.form-control:disabled {
  background-color: transparent !important;
}
.baseline_box {
  width: 100%;
}
.page-tips-shift {
  .title-3 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }

  .cont-request-text {
    .cont-title {
      color: #1c3a4e;

      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }

      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }

    .form-request {
      .button1 {
        font-family: "Open Sans";
        background: #e9ecee;
        color: #1c3a4e;
        font-weight: bold;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;

        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }

      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;
        padding-left: 2%;
        padding-right: 2%;

        &:hover {
          background: darken(#7a7c7e, 5);
        }

        .button3 {
          border-radius: 50px;
          font-family: "Open Sans";
          color: #1c3a4e;
          font-size: 20px;
          border: 0 none;
          outline: none;
          text-decoration: none;
          border: 2px solid #1c3a4e;
        }
      }
    }
  }

  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #979494;
    text-align: center !important;
  }

  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .button4 {
    background: #99a6af;
    color: #ffffff;
    border-radius: 8px;
    height: 20px;
    font-size: 8px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;

    &:hover {
      background: darken(#99a6af, 5);
    }
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg2 {
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    padding-right: 2%;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }

  .mycheck {
    width: 1.3em;
    height: 1.3em;

    border-radius: 30%;
    vertical-align: middle;
    border: 1px solid #ddd;
    //-webkit-appearance: none;
  }

  .mycheck:checked {
    background-color: #1c3a4e;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  /*
  input:checked + .slider {
    background-color: #779B49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779B49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }*/

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  /* Center the loader */
  #loader {
    position: relative;
    z-index: 1072;
    left: 50%;
    top: 50%;
    z-index: 1;

    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .content-loader {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1071;
    background-color: #fff;
    opacity: 0.9;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  /*.card-header{
    
    background-color: none !important;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }*/

  .chips {
    /* Auto Layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    width: 61px;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    /* Alert / Error Bg */
    background: #feefef;
    border-radius: 4px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .iconClose {
    /* Alert/Error */
    color: #da1414;
  }

  .iconPendiente {
    /* Alert/Error */
    color: #e06100;
  }

  .iconTerminado {
    /* Alert/Error */
    color: #0c9e42;
  }

  .iconProceso {
    /* Alert/Error */
    color: #2e5aac;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .textClose {
    position: static;
    height: 16px;
    left: 22px;
    right: 4px;
    top: calc(50% - 16px / 2);
    /* Placeholder */
    font-family: Open Sans;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    /* Alert/Error */
    color: #da1414;
  }

  .card-header {
    width: 100%;
    //@errorbackground: #EDF9F0;
    border-bottom: none;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background: #ececff !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;

    //margin: 24px 0px;
  }

  .card-personalizada2 {
    /* employee list / full / master */

    /* Auto layout */

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;

    position: static;
    width: 382px;
    height: auto;
    left: calc(50% - 382px / 2 + 1px);
    top: calc(50% - 116px / 2);

    /* content/00 */

    background: #ffffff;
    /* mid */

    box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
    border-radius: 8px;
    margin-top: 24px;
  }

  .card-personalizada3 {
    /* Auto layout */

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;

    position: static;
    width: 981px;

    width: auto;
    left: 0px;
    top: 926px;

    /* content/00 */

    background: #ffffff;
    /* content/01 */

    border: 1px solid #eceff1;
    box-sizing: border-box;
    /* up extra */

    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px;

    /* Inside auto layout */

    order: 3;
    flex-grow: 0;
    margin: 32px 0px;
  }

  .card-personalizada3-enblanco {
    position: static;
    width: 460px;
    height: 140px;
    left: 0px;
    top: 926px;
    /* content/00 */

    background: #ffffff;
    /* content/01 */

    border: 1px solid #eceff1;
    box-sizing: border-box;
    /* up extra */

    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px;
  }

  .card-left {
    /* Auto Layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 16px;
    /* Neutral / White */
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 0px solid #dddddd;
    box-sizing: border-box;
    /* up extra */
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
  }

  .card-text-name {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 50%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .ancho-completo {
    width: 100%;
  }

  .card-text-name-bodega {
    /* Body Tablas - Párrafo mediano */
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 50%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .text-proceso {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1c3a4e;
  }

  .text-pendiente {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1c3a4e;
  }

  .text-terminado {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1c3a4e;
  }

  .chips-bodega-pendiente {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #fff4ec;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .chips-bodega-proceso {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #eef2fa;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .chips-bodega-terminado {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #edf9f0;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .card-body {
    padding-top: 10px;
    //padding-left: 0px;
    //padding-bottom: 10px;
  }

  .card-text-cargo {
    /* Body Tablas - Párrafo mediano */

    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: right;

    /* Neutral / Gray 1 */

    color: #454545;

    /* Inside Auto Layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 4px;

    // Elipsis cargo
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .card-left-titulo {
    /* Header Tablas */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    /* Primary / 1 */
    color: #1c3a4e;
  }

  .table {
    border-collapse: collapse !important;
    border-radius: 8px !important;
    //box-shadow:rgba(0, 0, 0, 0.14);
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.14);

    //filter: drop-shadow(0px 0px 9px rgba(0, 0, 0, 0.14));
  }

  thead>tr {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    /* Alert / Info Bg */
    // background:blue;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin: 0px 0px;

    /* table header */

    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    /* or 133% */

    align-items: center;

    /* content/06 */

    color: #546e7a !important;
  }

  tbody>tr {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    border-bottom: 1px solid #eceff1;
    /* Neutral / Gray 1 */
    //color: #454545;
  }

  table>input {
    border: 1px solid #aaaaaa;
    box-sizing: border-box;
    border-radius: 2px;
    background: #269887;
  }

  thead th {
    background-color: #eceff1;
  }

  thead th:first-child {
    border-radius: 8px 0 0 0px;
  }

  thead th:last-child {
    border-radius: 0 8px 0px 0;
  }

  /* remove border from th... */
  /* !important is only required in stack snippet, probably not in your production code */

  .table>thead>tr>th {
    //border: none !important;
    border-right: #cfd8dc solid 1px;
  }

  .table>tbody>tr>td {
    //border: none !important;
    border-right: #cfd8dc solid 1px;
    border-spacing: 1 !important;
  }

  /* remove border from first tbody row... */
  .table>tbody>tr:first-child>td,
  .table>tbody>tr:first-child>th {
    border-top: none;
  }

  .selection-table {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    border-radius: 8px;
  }

  .btn {
    background: #269887;
    border: transparent;
  }

  .btn:hover {
    background: #1c6776;
    border: transparent;
  }

  .text-novedad-info {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;
    /* Primary / 3 */
    color: #269887;
  }

  // Tabla de reemplazos, rotativos, editar puntaje
  .tabs-novedades {
    .col-auto {
      background-color: transparent;
    }

    ul {
      background-color: transparent;
    }

    .nav-item {
      background-color: transparent;
      border-bottom: 1px solid #e9ecee;
      width: 180px;

      a {
        color: black;
      }
    }

    .nav-pills {
      margin-left: 0px;
      padding-left: 0px;
      margin-top: 10px;
    }

    .nav-link {
      height: 80px;
      margin-left: 0px;
      padding-left: 0px;
      background-color: transparent;
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
    }

    .nav-pills .nav-link.active,
    .nav-pills .show>.nav-link {
      color: black;
      background-color: white;
      /* Neutral / Black */
      color: #000000;
    }

    .page-tips-shift .tabs .nav-link {
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
      /* Neutral / Black */
      color: #000000;
      background-color: white;
    }

    .tab-title-content {
      height: 60px;
      padding-left: 5px;
      //border-left: 4px solid transparent;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .nav-link.active>.tab-title-content {
      border-left: 4px solid #269887;
    }

    .tab-title-muted-ul {
      margin: 0px;
      padding: 0px;
    }

    .tab-title-muted {
      /* Body Semibold */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      /* Primary / 3 */
      color: #269887;
    }

    .tab-title-r {
      color: #269887;
      //margin-top: 15px;
      vertical-align: middle;
    }

    .tab-title-r-10 {
      color: #269887;
      margin-top: 3px;
    }

    /*.card-header-novedad{
      
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #2f3d46;
      background: #F5F5F5;
    }
*/
    .text-novedad-descripcion {
      /* Header Tablas */
      /* body regular */

      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* identical to box height, or 175% */

      /* content/09 */

      color: #263238;

      /* Inside auto layout */

      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      margin: 4px 0px;
    }

    .text-novedad-buscar {
      /* Body Tablas - Párrafo mediano */
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      /* identical to box height */
      display: flex;
      align-items: center;
      justify-content: center;
      /* Neutral / Gray 1 */
      color: #454545;
    }
  }

  .text-buscar {
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 1px solid #b0bec5;
    box-sizing: border-box;
    border-radius: 22px !important;

    .input-group-prepend {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .input-group {
      width: 50px !important;
    }

    .icon-search1 {
      color: #dadada;
    }

    .icon-search1::before {
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: center;
    }

    input {
      height: 40px;
      border: 0px;
      margin-left: -10px;
      margin-right: 15px;
      width: 300px;
      outline: 0;

    }

    ::placeholder {
      //font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #aaaaaa;
    }
  }

  .label-textarea {
    margin-top: 0px;

    //width:100%;
  }

  .label-textarea label {
    width: 100%;
    position: relative;
    top: 20px;
    left: 30px;
    margin-top: 0px;
    border-radius: 1px;
    background: white;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 2 */
    color: #aaaaaa;
    text-align: left;
  }

  .textarea-novedad {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #454545;

    background: #ffffff;
    border: 1px solid #aaaaaa;
    box-sizing: border-box;
    border-radius: 8px;
    width: 98%;
    height: 92px;
    margin-top: 10px;
    padding-top: 10px;
    scroll-behavior: auto;

    ::placeholder {
      margin-top: 100px;
    }
  }

  .contenedor-quitar {
    width: 100%;
  }

  .ver-historial {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* Primary / 3 */
    color: #269887;
  }

  .btn-descartar {
    /* Primary / 3 */
    background: white;
    border-radius: 100px;
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #da1414;
  }

  .btn-descartar:hover {
    /* Primary / 3 */
    background: white;
    border-radius: 100px;
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #da1414;
  }

  .alert-custom-danger {
    /* Alert / Warning Bg */
    background: #fff4ec;
    border-radius: 8px;
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Black */
    color: #000000;
    border: 0px;
  }

  .contenedor-reloj {
    background: #edf9f0;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px rgba(110, 116, 134, 0.12);
    border-radius: 8px;
  }

  .icono-calendar {
    font-size: 50px;
    color: #dadada;
  }

  .titulo-reloj {
    /* Ag / Menu */
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height, or 117% */

    letter-spacing: 0.015em;

    color: #000000;
  }

  .content-reloj {
    /* Botón */
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */

    letter-spacing: 0.02em;

    /* Neutral / Black */

    color: #000000;
  }

  .contenedor-reloj {
    background: #edf9f0;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px rgba(110, 116, 134, 0.12);
    border-radius: 8px;
  }

  .icono-calendar {
    font-size: 50px;
    color: #dadada;
  }

  .titulo-reloj {
    /* Ag / Menu */
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height, or 117% */

    letter-spacing: 0.015em;

    color: #000000;
  }

  .content-reloj {
    /* Botón */
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */

    letter-spacing: 0.02em;

    /* Neutral / Black */

    color: #000000;
  }

  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: static;
    width: 428px;
    height: 44px;
    left: calc(50% - 428px / 2);
    top: calc(50% - 44px / 2);

    /* content/00 */

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    box-sizing: border-box;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 0px;
  }

  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .button-confirmar {
    position: static;
    width: 221px;
    height: 40px;
    left: 10px;
    top: 32px;
    padding: 8px 8px 8px 16px;

  }

  .content-toggle {
    /* _tab variants / horizontal */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;

    border: none;
    box-sizing: border-box;

    position: static;
    width: 376px;
    height: 56px;
    left: 28px;
    top: 228px;

    /* Inside auto layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 30px 0px;

    .toggle-search {
      /* Auto layout */

      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 8px;

      position: static;
      left: 0%;
      right: 0%;
      top: 0%;
      bottom: 0%;

      /* CTA/00 */

      background: #ececff;
      /* CTA/01 */

      border: 1px solid #c9caff;
      box-sizing: border-box;
      border-radius: 48px;

      /* Inside auto layout */

      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0px 0px;
    }
  }

  .Novedades {
    /* Auto layout */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px;

    position: static;
    width: 16px;
    height: 16px;
    left: 128px;
    top: 12px;

    /* highlight/info/medium */

    background: #0075ff;
    border-radius: 100px;
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;

    /* Inside auto layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 8px;
  }
}

.text-buscar {
  background: #ffffff;
  /* Neutral / Gray 3 */
  border: 1px solid #dddddd;
  box-sizing: border-box;
  border-radius: 8px;


  .input-group-prepend {
    width: 40px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px !important;

  }

  .input-group {
    width: 50px !important;


  }

  .icon-search1 {
    color: #dadada;
  }

  .icon-search1::before {
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: center;
  }
}

.reloj-letras {
  padding: 0px;

  position: static !important;

  height: 48px;
  left: calc(50% - 382px / 2) !important;
  top: calc(50% - 48px / 2) !important;

  /* highlight/info/background */

  background: #e6f7ff;
  /* highlight/info/medium */

  border: 1px solid #0075ff;
  box-sizing: border-box;
  border-radius: 4px;
}

.contenedor-quitar {
  width: 100%;
}

.ver-historial {
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  /* Primary / 3 */
  color: #269887;
}

.btn-descartar {
  /* Primary / 3 */
  background: white;
  border-radius: 100px;
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #da1414;
}

.btn-descartar:hover {
  /* Primary / 3 */
  background: white;
  border-radius: 100px;
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #da1414;
}

.alert-custom-danger {
  /* Alert / Warning Bg */
  background: #fff4ec;
  border-radius: 8px;
  /* Body Tablas - Párrafo mediano */
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  /* Neutral / Black */
  color: #000000;
  border: 0px;
}

.buscar-empleado {
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;

  position: static;
  width: 428px;
  height: 44px;
  left: calc(50% - 428px / 2);
  top: calc(50% - 44px / 2);

  /* content/00 */

  background: #ffffff;
  /* content/03 */

  border: 1px solid #b0bec5;
  box-sizing: border-box;
  border-radius: 22px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 0px 0px;
}

.buscar-empleado .form-control {
  border: 0px !important;
  font-family: Ubuntu !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 28px !important;
}

.contenedor-quitar {
  width: 100%;
}

.ver-historial {
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  /* Primary / 3 */
  color: #269887;
}

.btn-descartar {
  /* Primary / 3 */
  background: white;
  border-radius: 100px;
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #da1414;
}

.btn-descartar:hover {
  /* Primary / 3 */
  background: white;
  border-radius: 100px;
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #da1414;
}

.alert-custom-danger {
  /* Alert / Warning Bg */
  background: #fff4ec;
  border-radius: 8px;
  /* Body Tablas - Párrafo mediano */
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  /* Neutral / Black */
  color: #000000;
  border: 0px;
}

.buscar-empleado {
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;

  position: static;
  width: 428px;
  height: 44px;
  left: calc(50% - 428px / 2);
  top: calc(50% - 44px / 2);

  /* content/00 */

  background: #ffffff;
  /* content/03 */

  border: 1px solid #b0bec5;
  box-sizing: border-box;
  border-radius: 22px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 0px 0px;
}

.buscar-empleado .form-control {
  border: 0px !important;
  font-family: Ubuntu !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 28px !important;
}

.button-confirmar {
  position: static;
  width: 221px;
  height: 40px;
  left: 10px;
  top: 32px;
  padding: 8px 8px 8px 16px;
  /* CTA/03 */

}

.content-toggle {
  /* _tab variants / horizontal */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  border: none;
  box-sizing: border-box;

  position: static;
  width: 376px;
  height: 56px;
  left: 28px;
  top: 228px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 30px 0px;

  .toggle-search {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px;

    position: static;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;

    /* CTA/00 */

    background: #ececff;
    /* CTA/01 */

    border: 1px solid #c9caff;
    box-sizing: border-box;
    border-radius: 48px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 0px;
  }
}

.Novedades {
  /* Auto layout */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;

  position: static;
  width: 16px;
  height: 16px;
  left: 128px;
  top: 12px;

  /* highlight/info/medium */

  background: #0075ff;
  border-radius: 100px;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;

  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 0px 8px;
}

.text-buscar {
  background: #ffffff;
  /* Neutral / Gray 3 */
  border: 1px solid #dddddd;
  box-sizing: border-box;
  border-radius: 8px;

  .input-group-prepend {
    width: 40px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px !important;

  }

  .input-group {
    width: 50px !important;

  }

  .icon-search1 {
    color: #dadada;
  }

  .icon-search1::before {
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: center;
  }
}

.input-text:valid+.label-helper {
  color: #78909C;
  opacity: 1;
}

.input-text:focus+.label-helper,
.input-text:active+.label-helper {
  color: #5D5FEF;
  opacity: 1;
}
</style>
